import styled from '@emotion/styled';
import { Theme } from '@/styles/Theme';
import { css } from '@emotion/react';

export const TableContainer = styled.div`
  width: 100%;
  margin: 0.625rem 0;
  overflow-x: auto;
`;

export const TableHeader = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0.75rem;
  padding: 0;
`;

export const Table = styled.table`
  width: 100%;
  margin: 0;
  table-layout: auto;

  th,
  td {
    border: 0.0625rem solid ${Theme.colors.G_3};
  }

  thead {
    tr {
      border-bottom: 0.1875rem solid ${Theme.colors.G_2};
    }
  }

  tbody {
    tr:hover {
      background-color: ${Theme.colors.G_6};
    }
  }
`;

export const Tr = styled.tr`
  background-color: ${Theme.colors.WHITE};
`;

export const Th = styled.th`
  position: relative;
  font-weight: 700;
  padding: 0.9375rem 0.3125rem;
  white-space: nowrap;

  & > span {
    cursor: pointer;
  }

  :hover {
    div {
      opacity: 1;
    }
  }
`;

export const Td = styled.td`
  padding: 0.9375rem 0.3125rem;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 0;
`;

export const ResizerLine = styled.div<{ isResizing: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 0.3125rem;
  opacity: 0;
  background: rgba(0, 0, 0, 0.5);
  cursor: col-resize;
  user-select: none;
  touch-action: none;

  ${({ isResizing }) =>
    isResizing &&
    css`
      background: blue;
      opacity: 1;
    `}
`;

export const StatusBadge = styled.span<{ color: string }>`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  background-color: ${({ color }) => color};
  color: white;
  font-size: 0.875rem;
  font-weight: 600;
`;

